import { Text } from '../../../../../../../shared/components/Text';

export const getItemTooltip = (item) => (
  <>
    <p>{item.article.description}</p>
    <p>
      {item.article.category && (
        <>
          <Text tId={'CATEGORY'} /> {': '}
          {item.article.category}
        </>
      )}
      <br />
      {item.article.type && (
        <>
          <Text tId={'TYPE'} /> {': '}
          {item.article.type}
        </>
      )}
    </p>
  </>
);
